import { render, staticRenderFns } from "./madera.vue?vue&type=template&id=3fa64a1e&"
import script from "./madera.vue?vue&type=script&lang=js&"
export * from "./madera.vue?vue&type=script&lang=js&"
import style0 from "./madera.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports